<template>
  <div>
    <div class="title">{{ model.title }}</div>
    <div class="content">{{ model.content }}</div>
  </div>
</template>

<script>
import api from '../../utils/api'

export default {
  name: 'DailyRecommendPage',
  computed: {
    imgWidth: function () {
      return 100.0 * 670.0 / 750 + 'vw'
    },
    imgHeight: function () {
      return 300.0 * 100.0 / 750 + 'vw'
    },
    showImage: function () {
      return this.model.img.length > 0
    }
  },
  data () {
    return {
      imageStyle: {
        width: 100. * 670.0 / 750.0 + 'vw',
        height: 100. * 300.0 / 750.0 + 'vw'
      },
      model: {
        id: '',
        title: '',
        content: '',
        img: '',
        createTime: ''
      }
    }
  },
  methods: {},
  mounted () {
    // todo 写死的,需要修改
    api.dailyRecommendInfo(this.$route.query.id).then((value) => this.model = value)
  }
}
</script>

<style scoped>
.title {
  font-size: 0.4rem;
  margin-left: .4rem;
  text-align: left;
  font-weight: 500
}

.avatar {
  margin-left: .4rem;
  border-radius: 30px;
  height: 30px;
  width: 30px
}

.des {
  font-size: 0.26rem;
  margin-left: .2rem;
  text-align: left;
  color: #333333;
}

.createTime {
  font-size: 0.20rem;
  margin-left: .2rem;
  text-align: left;
  color: #999999

}

.desContent {
  margin-top: .2rem;
  display: flex;
  align-items: center;
}


.content {
  margin-top: .4rem;
  text-align: left;
  margin-left: .4rem;
  margin-right: .4rem;
  font-size: 0.32rem;
  color: #333333;
  line-height: 1.7;
  white-space: pre-wrap;
}

.articleImg {
  margin-left: .4rem;
  margin-right: .4rem;
  object-fit: cover;
  margin-bottom: .4rem;
}
</style>



// WEBPACK FOOTER //
// src/modules/kuaizhen/DailyRecommendPage.vue